import React, { useEffect } from 'react';

import { useExportContext } from 'lib/context/ExportContext/ExportContext';

import PrintViewHeader from 'components/Patient/quote/components/PrintViewHeader';

const InvoicePrintView = ({
  exportId,
  practice,
  patient,
  content,
  createdAt,
  hiddenFields = {}
}) => {
  const { setHeaderConfigs } = useExportContext();

  //set current patient in export context

  useEffect(() => {
    setHeaderConfigs(exportId, { patient: { ...patient, service_date: createdAt }, hiddenFields });
  }, [exportId, createdAt, JSON.stringify(patient), hiddenFields]);

  return (
    <div className="flex h-full grow justify-center overflow-hidden bg-neutral-200 print:bg-white print:!p-0">
      <div className="print:!page-break-before flex h-full w-full flex-col bg-white print:w-full ">
        <PrintViewHeader
          practice={practice}
          patient={patient}
          createdAt={createdAt}
          hiddenFields={hiddenFields}
        />

        <div className="flex w-full flex-col gap-[6px] whitespace-pre-line bg-white !outline-none print:!mb-0 print:break-inside-auto">
          {content}
        </div>
      </div>
    </div>
  );
};

export default InvoicePrintView;
